import {useForm} from "react-hook-form"
import {Role} from "dto/Role"
import {useEffect} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {NotificationType, showNotification} from "common/Notification"
import {useFindGroupById, useUpdateGroup} from "hooks/query/group-query"

export function UpdateGroupForm() {
    const navigate = useNavigate()
    const {id} = useParams()
    const {data: group} = useFindGroupById(id)
    const updateMutate = useUpdateGroup()

    const {register, setValue, getValues, watch, handleSubmit} = useForm<Role>()

    useEffect(() => {
        if (!group) return
        setValue("name", group.name)
        setValue("id", group.id)
    }, [group, setValue])

    const submit = (values: Role) => {
        const role = {
            id: values.id,
            name: values.name,
        }
        updateMutate.mutate(role, {
            onSuccess: () => {
                showNotification("그룹 정보를 수정하였습니다", NotificationType.SUCCESS)
            },
            onError: () => {
                showNotification("그룹 정보수정이 실패하였습니다")
            }
        })
    }

    if (!group) return null
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="mt40 ml20">
                <div className="gray-label is-size-85">그룹명</div>
                <div className="">
                    <input className="input is-gray" type="text" placeholder="그룹명"
                           {...register("name",)}
                    />
                </div>
            </div>
            <div className="mt30 ml20">
                <button className="button is-purple2">수정</button>
                <div className="is-clickable button ml-2" onClick={() => navigate("/group/list")}>목록으로</div>
            </div>
            <div className="hr-line-dashed mt30"/>
        </form>
    )
}